import script from "./CheckInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckInfo.vue?vue&type=script&setup=true&lang=js"

import "./CheckInfo.vue?vue&type=style&index=0&id=8e7e15fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e7e15fa"]])

export default __exports__